<template>
  <div class="content q-mt-sm">
    <template v-if="rows.length">
      <div
        :class="[
          'full-width row items-center justify-start',
          { 'q-mt-md': !!portIndex },
        ]"
        v-for="(row, portIndex) in rows"
        :key="`port-${portIndex}`"
      >
        <q-icon
          class="self-start"
          :name="row.icon"
          color="grey-9"
          size="16px"
        />

        <div class="column items-start justify-start col q-pl-sm">
          <div class="text-weight-bold">{{ row.title }}</div>

          <template v-if="row.description && row.description.length">
            <div
              v-for="(description, descriptionIndex) in row.description"
              :key="`port-description-${descriptionIndex}-${portIndex}`"
            >
              {{ description }}
            </div>
          </template>

          <div
            class="row full-wdith items-center justify-start"
            v-if="row.arriveTime || row.departureTime"
          >
            <span v-if="row.arriveTime"> Arrival {{ row.arriveTime }} </span>
            <span class="q-px-xs" v-if="row.arriveTime && row.departureTime">
              -
            </span>
            <span v-if="row.departureTime">
              Departure {{ row.departureTime }}
            </span>
          </div>
        </div>

        <div
          class="full-width column items-start justify-start excursions q-mt-sm q-pl-lg"
          v-if="row.excursions && row.excursions.length"
        >
          <div
            class="row full-width items-center text-uppercase justify-start header"
          >
            <div class="text-weight-bold header-cell col">
              {{ row.excursions.length }} excursion{{
                row.excursions.length > 1 ? "s" : ""
              }}
            </div>
            <!-- <div class="text-weight-bold header-cell text-center">info</div> -->
          </div>

          <div class="column full-width items-center justify-start body">
            <div
              class="row items-center q-py-sm justify-start body-row full-width"
              v-for="(ex, exIndex) in row.excursions"
              :key="`ex-body-${exIndex}-${portIndex}`"
            >
              <div class="body-cell col">
                {{ ex.title }}
              </div>

              <div class="body-cell text-center" v-if="ex.features">
                <q-icon name="o_info" color="secondary" size="16px">
                  <q-tooltip
                    anchor="center left"
                    self="center right"
                    :delay="500"
                  >
                    <div
                      v-for="(feature, featureIndex) in ex.features"
                      :key="`ex-body-feature-${featureIndex}-${exIndex}-${portIndex}`"
                    >
                      <span> {{ feature.label }} </span>:
                      <span> {{ feature.value }} </span>
                    </div>
                  </q-tooltip>
                </q-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "DItineraryListPorts",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    rows: {
      get() {
        return this.item.rows ?? [];
      },
    },
  },
};
</script>
